<script lang="ts">
  import { orgExternalLink, orgHelp } from "@nrk/origo";

  export let header: string;
  export let link: string;
</script>

<button type="button" class="org-button question">
  {@html orgHelp}
</button>
<bb-dropdown hidden class="box">
  <h2 class="header">{header}</h2>
  <slot />
  <a href={link} target="_blank" class="link">
    Les mer på Portalen {@html orgExternalLink}
  </a>
</bb-dropdown>

<style>
  .header {
    font-size: 14px;
    font-weight: bold;
    margin-top: 3px;
    margin-bottom: 3px;
  }
  .question {
    font-size: 0.7rem;
    padding-left: 0;
  }

  .box {
    background-color: var(--color-info-surface-primary);
    color: var(--color-text-invert);
    padding: var(--org-small);
    width: 22rem;
  }
  .link {
    color: var(--org-color-focus);
    font-size: 12px;
  }
</style>
